<div class="campaign-registration-successful-container">
  @if (isLoading()) {
    <app-spinner class="campaign-registration-spinner"></app-spinner>
  }
  <ngx-app-bar
    class="w-100"
    [title]="'دریافت جایزه گنج'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="campaign-registration-successful-content">
    <div class="campaign-registration-successful-image">
      <img
        src="wealth-assets/images/treasure-hunt-1.svg"
        alt=""
        class="w-100"
      />
    </div>
    <div class="campaign-registration-title">{{ state?.remainingDays }} روز کاری باقی مانده!</div>
    <div class="campaign-registration-description">
      <span>درخواست شما برای دریافت جایزه گنج ثبت شد.</span>
      <span> تا {{ state?.remainingDays }} روز کاری آینده شما را از طریق پیامک باخبر می‌کنیم. </span>
      <span>در این فرصت می‌توانید در دارایی‌های دیگر سرمایه‌گذاری کنید.</span>
    </div>
    <div class="campaign-registration-wrapper">
      <div
        class="campaign-registration-investment"
        (click)="onCardClick('FixedIncome')"
      >
        <div class="campaign-registration-investment-icon">
          <img
            src="wealth-assets/svg/safe-box.svg"
            alt=""
          />
        </div>
        <div class="campaign-registration-investment-text">
          <span class="campaign-registration-investment-title">صندوق‌های درامد ثابت</span>
        </div>
      </div>
      <div
        class="campaign-registration-investment"
        (click)="onCardClick('Gold')"
      >
        <div class="campaign-registration-investment-icon">
          <img
            src="wealth-assets/svg/icon-gold.svg"
            alt=""
          />
        </div>
        <div class="campaign-registration-investment-text">
          <span class="campaign-registration-investment-title">سرمایه‌گذاری مبتنی بر طلا</span>
        </div>
      </div>
    </div>
    <div class="campaign-registration-button">
      <ngx-button
        [buttonId]="'CAMPAIGN_REGISTRATION_SUCCESS'"
        size="medium"
        [fullWidth]="true"
        (clickHandler)="onBackHandler()"
        mode="form"
      >
        متوجه شدم
      </ngx-button>
    </div>
  </div>
</div>
